









import { Component, Prop, Vue } from 'vue-property-decorator';
import DropdownInput from '@/baklava/input/DropdownInput.vue';

@Component({
  components: { DropdownInput },
})
export default class Dropdown extends Vue {
  @Prop() value!: string;

  @Prop({ type: String }) name!: string;

  @Prop({ type: Object })
  option!: { items: [string] };

  private items = this.option.items || [];

  updateValue(newValue: string) {
    this.$emit('input', newValue);
  }
}
